import React from "react";
import PropTypes from "prop-types";

import { API_URL_BASE, DMService } from "../../../API/server_calls";

import * as Theme from "../../../App/Theme";

import * as GBConst from "../../GB/NonComponents/GBConst";
import { shouldComponentUpdateGB } from "../../GB/NonComponents/GBUtil";

import TLabel from "../../../Library/Labels/TLabel";
import TCheckBoxLabel from "../../../Library/Labels/TCheckBoxLabel";
import TRadioGroup from "../../../Library/RadioGroups/TRadioGroup";

import GBStdTable from "../../../Library/Tables/GBStdTableAG/GbStdTable";

import * as DMConst from "../NonComponents/DMConst";
import { getVMMC_AgeGroupStr } from "../NonComponents/DMUtil";
import { getVMMC_TargCov1DFltArray } from "../NonComponents/DMDataUtil";

import TComboBox from "../../../Library/ComboBoxes/TComboBox";
import TButton from "../../../Library/Buttons/TButton";

class DMAppSideBarCustom extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        /* DM data */
        countryObjList: PropTypes.arrayOf(PropTypes.object).isRequired,
        province1DStrArray: PropTypes.array.isRequired,

        //recalculateBool           : PropTypes.bool.isRequired,
        onRecalculateChange: PropTypes.func.isRequired,

        selectedCountryMstID: PropTypes.number.isRequired,
        onCountryChange: PropTypes.func.isRequired,

        selectedFiscalYearStart: PropTypes.number.isRequired,
        onFiscalYearStartChange: PropTypes.func.isRequired,

        selectedProvinceCurrID: PropTypes.number.isRequired,
        onProvinceChange: PropTypes.func.isRequired,

        selectedSNU_CurrID: PropTypes.number.isRequired,
        onSNU_Change: PropTypes.func.isRequired,

        selectedTargetYear: PropTypes.number.isRequired,
        onTargetYearChange: PropTypes.func.isRequired,

        showGlobalOutputsBool: PropTypes.bool.isRequired,
        onShowGlobalOutputsChange: PropTypes.func.isRequired,

        SNU_1DStrArray: PropTypes.array.isRequired,

        VMMC_Coverage: PropTypes.arrayOf(PropTypes.array).isRequired,
        onVMMC_CoverageChange: PropTypes.func,

        VMMC_BaseCoverageYear: PropTypes.number.isRequired,

        //allowedCountryMstIDs : PropTypes.array,
        onDrawerChange: PropTypes.func,
        isGuest: PropTypes.bool,
        pageID: PropTypes.string,
        onPageChange: PropTypes.func,
        handleTargBySNU: PropTypes.func,

        width: PropTypes.number,
    };

    static defaultProps = {
        countryObjList: {},
        province1DStrArray: [],

        //recalculateBool           : true,
        onRecalculateChange: () => console.log("onRecalculateChange"),

        selectedCountryMstID: 0,
        onCountryChange: () => console.log("onCountryChange"),

        selectedFiscalYearStart: DMConst.janFYS,
        onFiscalYearStartChange: () => console.log("onFiscalYearStartChange"),

        selectedProvinceCurrID: 0,
        onProvinceChange: () => console.log("onProvinceChange"),

        selectedSNU_CurrID: 0,
        onSNU_Change: () => console.log("onSNU_Change"),

        selectedTargetYear: DMConst.defaultTargetYear,
        onTargetYearChange: () => console.log("onTargetYearChange"),

        showGlobalOutputsBool: false,
        onShowGlobalOutputsChange: () => console.log("onShowGlobalOutputsChange"),

        SNU_1DStrArray: [],

        VMMC_Coverage: [],
        onVMMC_CoverageChange: () => console.log("onVMMC_CoverageChange"),

        VMMC_BaseCoverageYear: DMConst.firstPossibleTargetYear,

        //allowedCountryMstIDs : [],
        isGuest: true,
        onDrawerChange: () => console.log("onDrawerChange"),
        pageID: "",
        onPageChange: () => console.log("onPageChange"),
        handleTargBySNU: () => console.log("handleTargBySNU"),
        width: 300,
    };

    state = {
        pastedVal: null,
    };

    /* Avoid re-rendering if we don't have to (if no props or state affect this form). */
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdateGB(this.props, nextProps, this.state, nextState);
    }

    //==================================================================================================================
    //
    //                                                 Utility
    //
    //==================================================================================================================

    getCountryComboBoxItemIndex = () => {
        try {
            let itemIndex = 0;

            const props = this.props;
            const selectedCountryMstID = props.selectedCountryMstID;
            const countryObjList = props.countryObjList;

            let i = 1;

            if (countryObjList.length >= 1) {
                while (i <= countryObjList.length) {
                    if (countryObjList[i - 1][DMConst.countryObjMstID] === selectedCountryMstID) {
                        itemIndex = i - 1;
                    }

                    i++;
                }
            }

            return itemIndex;
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
            return -1;
        }
    };

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    onCountryComboBoxChange = (value, text, info) => {
        try {
            this.props.onCountryChange(info);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onProvinceComboBoxChange = (value, text, info) => {
        try {
            this.props.onProvinceChange(value + 1);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onSNU_ComboBoxChange = (value, text, info) => {
        try {
            this.props.onSNU_Change(value + 1);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onTargetYearComboBoxChange = (value, text, info) => {
        try {
            this.props.onTargetYearChange(text);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onFiscalYearStartComboBoxChange = (value, text, info) => {
        try {
            this.props.onFiscalYearStartChange(value + 1);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onShowGlobalOutputsCheckBoxClick = (checked, event, name, caption, info) => {
        try {
            this.props.onShowGlobalOutputsChange(checked);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onRecalculateCheckBoxClick = (checked, event, name, caption, info) => {
        try {
            this.props.onRecalculateChange(checked);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onDisplayAllCoverages = (obj, val) => {
        try {
            if (obj === 1) {
                this.props.onPageChange(DMConst.DMCoverageFormPg);
                this.props.handleTargBySNU(true);
            } else {
                this.props.onPageChange(DMConst.DMWelcomeFormPg);
                this.props.handleTargBySNU(false);
            }
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onDownloadOutputTableBtnClick = () => {
        try {
            const props = this.props;
            const DM = this.props.DM;
            const selectedCountryMstID = props.selectedCountryMstID;
            const selectedProvinceCurrID = props.selectedProvinceCurrID;
            const selectedSNU_CurrID = props.selectedSNU_CurrID;
            const selectedTargetYear = props.selectedTargetYear;
            const selectedFiscalYearStart = props.selectedFiscalYearStart;
            const VMMC_Coverage = props.VMMC_Coverage;
            const showGlobalOutputsBool = props.showGlobalOutputsBool;
            const useSNU = DM.targCoverageBySNU.useSNU && DM.targCoverageBySNU.coverages != null;

            DMService.generateLink(
                "output",
                selectedCountryMstID,
                selectedProvinceCurrID,
                selectedSNU_CurrID,
                selectedTargetYear,
                useSNU ? DM.targCoverageBySNU : getVMMC_TargCov1DFltArray(VMMC_Coverage),
                true,
                showGlobalOutputsBool,
                selectedFiscalYearStart,

                (response) => {
                    //window.open(window.API_URL_BASE + response, '_blank');

                    let res = response.substring(0, 5);

                    if (res === "Error") {
                        alert("An error has occured generating the link");
                    } else {
                        //console.log(response);

                        let a = document.createElement("a");
                        a.href = API_URL_BASE + "/" + response;
                        a.download = "output.csv";
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                    }
                }
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onDownloadCountryTemplateBtnClick = () => {
        try {
            const props = this.props;
            const selectedCountryMstID = props.selectedCountryMstID;

            DMService.downloadCountryTemplate(selectedCountryMstID, (response) => {
                window.open(window.API_URL_BASE + response, "_blank");
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onUploadCountryTemplateBtnClick = () => {
        try {
            this.refs.importUploader.click();
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    /* Fires when the user clicks ok, etc. in the dialog. */
    onUploadCountryTemplate = (event) => {
        try {
            let file = event.target.files[0];

            console.log("Uploading XLSX file: " + file);

            DMService.upload(
                file,
                GBConst.GB_DM,
                (result) => {
                    console.log(result);
                    alert("Data has been submitted for approval.");
                },
                () => {
                    alert("Failed to upload file.");
                }
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onTargCovChanged = (packTable) => {
        const tableData = packTable.tableData.value;

        let VMMC_TargCov1DFltArray = [];

        for (let r = 2; r <= tableData.length; r++) {
            VMMC_TargCov1DFltArray.push(tableData[r - 1][DMConst.targetCoverage]);
        }

        this.props.onVMMC_CoverageChange(VMMC_TargCov1DFltArray);
    };

    onPasteStart = (props, state) => (event) => {
        const range = event.api.getCellRanges()[0];
        if (range) {
            let VMMC_TargCov1DFltArray = [];

            for (let r = 0; r < props.VMMC_Coverage.length; r++) {
                VMMC_TargCov1DFltArray.push(props.VMMC_Coverage[r][DMConst.targetCoverage - 1]);
            }

            const firstRowIndex = range.startRow.rowIndex;
            const finalRowIndex = range.endRow.rowIndex;

            // Access the pasted value from the state
            const pastedValue = state.pastedVal;

            if (pastedValue !== undefined) {
                // Iterate over the range and apply the pasted value
                for (let rowIndex = firstRowIndex; rowIndex <= finalRowIndex; rowIndex++) {
                    VMMC_TargCov1DFltArray[rowIndex] = pastedValue;
                }
                this.props.onVMMC_CoverageChange(VMMC_TargCov1DFltArray);
            }
        }
    };

    processCellFromClipboard = (state) => (params) => {
        state.pastedVal = parseInt(params.value); // Capture the value being pasted and store it in state
        return params.value; // Allow the value to pass through
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        try {
            /* Props */
            const props = this.props;

            const countryObjList = props.countryObjList;
            const province1DStrArray = props.province1DStrArray;
            //const recalculateBool = props.recalculateBool;
            const selectedCountryMstID = props.selectedCountryMstID;
            const selectedFiscalYearStart = props.selectedFiscalYearStart;
            const selectedProvinceCurrID = props.selectedProvinceCurrID;
            const selectedSNU_CurrID = props.selectedSNU_CurrID;
            const selectedTargetYear = props.selectedTargetYear;
            const SNU_1DStrArray = props.SNU_1DStrArray;
            const VMMC_Coverage = props.VMMC_Coverage;
            const VMMC_BaseCoverageYear = props.VMMC_BaseCoverageYear;

            const width = props.width;

            const minorCompFontSize = 14;
            const majorCompFontSize = 24;

            /* Indents for all controls on the app side bar with respect to the left of the app side bar. */
            const indent1 = 10;
            const indent2 = 20;

            /* Minimum number of pixels we should have from the right side of the app side bar to any
               control on it. */
            const rightMargin = 10;

            const majorLabStyle = {
                color: "primary",
                fontSize: majorCompFontSize,
                marginLeft: indent1,
            };

            const minorLabStyle = {
                color: "secondary",
                fontSize: minorCompFontSize,
                marginLeft: indent2,
            };

            const comboBoxStyle = {
                fontSize: minorCompFontSize,
                width: 115,
            };

            const provinceComboBoxPixels = indent1;
            const countryComboBoxPixels = provinceComboBoxPixels + 5;
            const SNU_ComboBoxPixels = provinceComboBoxPixels + 27;
            const targetYearComboBoxPixels = provinceComboBoxPixels + 35;
            const fiscalYearStartComboBoxPixels = provinceComboBoxPixels + 5;

            const labelComboBoxDivStyle = {
                ...Theme.sideBySideStyle,
                ...Theme.vCenteredStyle,
            };

            const checkBoxStyle = {
                height: 15,
            };

            const listItemStyle = {
                marginLeft: indent1,
            };

            const optionsLab = (
                <TLabel
                    caption={"Options"}
                    style={{
                        ...majorLabStyle,
                        marginTop: 15,
                    }}
                />
            );

            const DataPrepAndUploadLink = (
                <p
                    key={"DataPrepAndUploadLink"}
                    style={{
                        fontFamily: Theme.fontFamily,
                        textAlign: "left",
                        marginLeft: indent2,
                    }}
                >
                    <i>
                        If your country is not shown in the dropdown list, the country team must download the
                        appropriate input form from the{" "}
                        <a
                            href="https://adr.unaids.org/en/dataset-2/vmmc-data-input-forms-2023"
                            target="_blank"
                        >
                            ADR
                        </a>
                        , fill it out, upload it to the{" "}
                        <a
                            href="https://adr.unaids.org/en/dataset-2/vmmc-data-input-forms-2023"
                            target="_blank"
                        >
                            ADR
                        </a>
                        , and notify Avenir Health. For more details, see{" "}
                        <a
                            href="resources/DM/download/DMPPT2%20Data%20Preparation%20&%20Upload.pdf"
                            target="_blank"
                        >
                            Data Preparation & Upload.
                        </a>
                    </i>
                </p>
            );

            const chooseCountryLab = (
                <TLabel
                    caption={"Choose country"}
                    style={{
                        ...minorLabStyle,
                    }}
                />
            );

            let countryNames1DStrArray = [];
            let countryMstIDs1DIntArray = [];

            for (let i = 1; i <= countryObjList.length; i++) {
                countryNames1DStrArray.push(countryObjList[i - 1].name);
                countryMstIDs1DIntArray.push(countryObjList[i - 1].mstID);
            }

            const countryComboBoxItemIndex = this.getCountryComboBoxItemIndex();

            const countryComboBox = (
                <TComboBox
                    onChange={this.onCountryComboBoxChange}
                    info={countryMstIDs1DIntArray}
                    itemIndex={countryComboBoxItemIndex}
                    items={countryNames1DStrArray}
                    style={{
                        ...comboBoxStyle,
                        marginLeft: countryComboBoxPixels,
                    }}
                />
            );

            const countryDiv = (
                <div
                    style={{
                        ...labelComboBoxDivStyle,
                    }}
                >
                    {chooseCountryLab}
                    {countryComboBox}
                </div>
            );

            const chooseProvinceLab = (
                <TLabel
                    caption={
                        DMConst.countryUseRegions.includes(selectedCountryMstID) ? "Choose region" : "Choose province"
                    }
                    style={{
                        ...minorLabStyle,
                    }}
                />
            );

            const provinceComboBox = (
                <TComboBox
                    onChange={this.onProvinceComboBoxChange}
                    itemIndex={selectedProvinceCurrID - 1}
                    items={province1DStrArray}
                    style={{
                        ...comboBoxStyle,
                        marginLeft: DMConst.countryUseRegions.includes(selectedCountryMstID) ? 25 : 10,
                    }}
                />
            );

            const provinceDiv = (
                <div
                    style={{
                        ...labelComboBoxDivStyle,
                    }}
                >
                    {chooseProvinceLab}
                    {provinceComboBox}
                </div>
            );

            const chooseSNU_Lab = (
                <TLabel
                    caption={"Choose SNU"}
                    style={{
                        ...minorLabStyle,
                    }}
                />
            );

            const SNU_ComboBox = (
                <TComboBox
                    onChange={this.onSNU_ComboBoxChange}
                    itemIndex={selectedSNU_CurrID - 1}
                    items={SNU_1DStrArray}
                    style={{
                        ...comboBoxStyle,
                        marginLeft: SNU_ComboBoxPixels,
                    }}
                />
            );

            const SNU_Div = (
                <div
                    style={{
                        ...labelComboBoxDivStyle,
                    }}
                >
                    {chooseSNU_Lab}
                    {SNU_ComboBox}
                </div>
            );

            const targetYearLab = (
                <TLabel
                    caption={"Target year"}
                    style={{
                        ...minorLabStyle,
                    }}
                />
            );

            let possibleTargetYears1DStrArray = [];
            for (let i = DMConst.firstPossibleTargetYear; i <= DMConst.lastPossibleTargetYear; i++) {
                possibleTargetYears1DStrArray.push(i.toString());
            }

            const targetYearComboBox = (
                <TComboBox
                    onChange={this.onTargetYearComboBoxChange}
                    itemIndex={selectedTargetYear - DMConst.firstPossibleTargetYear}
                    items={possibleTargetYears1DStrArray}
                    style={{
                        ...comboBoxStyle,
                        marginLeft: targetYearComboBoxPixels,
                    }}
                />
            );

            const targetYearDiv = (
                <div
                    style={{
                        ...labelComboBoxDivStyle,
                    }}
                >
                    {targetYearLab}
                    {targetYearComboBox}
                </div>
            );

            const fiscalYearStartLab = (
                <TLabel
                    caption={"Fiscal year start"}
                    style={{
                        ...minorLabStyle,
                    }}
                />
            );

            const fiscalYearStartComboBox = (
                <TComboBox
                    onChange={this.onFiscalYearStartComboBoxChange}
                    itemIndex={selectedFiscalYearStart - DMConst.janFYS}
                    items={["January", "April", "July", "October"]}
                    style={{
                        ...comboBoxStyle,
                        marginLeft: fiscalYearStartComboBoxPixels,
                    }}
                />
            );

            const fiscalYearStartDiv = (
                <div
                    style={{
                        ...labelComboBoxDivStyle,
                    }}
                >
                    {fiscalYearStartLab}
                    {fiscalYearStartComboBox}
                </div>
            );

            const showGlobalOutputsCheckBoxLab = (
                <TCheckBoxLabel
                    caption={"Show global outputs"}
                    onClick={this.onShowGlobalOutputsCheckBoxClick}
                    checkBoxStyle={checkBoxStyle}
                    listItemStyle={{
                        ...listItemStyle,
                        marginTop: 10,
                    }}
                    labelStyle={{
                        fontSize: minorCompFontSize,
                    }}
                    style={{
                        ...minorLabStyle,
                    }}
                    value={this.props.showGlobalOutputsBool}
                />
            );

            /*This will always be true now. 
			const recalcCheckBoxLab =
                <TCheckBoxLabel
                    caption       = {"Recalculate"}
                    onClick       = {this.onRecalculateCheckBoxClick}
                    checkBoxStyle = {checkBoxStyle}
                    listItemStyle = {{
                        ...listItemStyle,
                        marginBottom : 10,
                    }}
                    labelStyle    = {{
                        fontSize : minorCompFontSize,
                    }}
                    style         = {{
                        ...minorLabStyle,
                    }}
                    value         = {recalculateBool}
                />;*/

            const maleCircCovRG = (
                <TRadioGroup
                    caption={"MC coverage (%) choice "}
                    handleChange={this.onDisplayAllCoverages}
                    /* 
                    value         = {(this.props.pageID ===DMConst.DMCoverageFormPg)}*/

                    items={["National", "By SNU"]}
                    itemIndex={this.props.DM.targCoverageBySNU.useSNU ? 1 : 0}
                    labelStyle={{
                        fontSize: minorCompFontSize,
                    }}
                    listItemStyle={{
                        ...listItemStyle,
                        marginBottom: 10,
                    }}
                    style={{
                        ...minorLabStyle,
                    }}
                />
            );

            const ageGroupCol = 1;
            const baseCovCol = 2;
            const targCovCol = 3;
            const numCols = 3;

            const headerRow = 1;
            const numRows = DMConst.numVMMC_AgeGroups + 1;

            const GBColWidths1DIntArray = [60, 95, 95];
            let GBRowHeights1DIntArray = [];
            GBRowHeights1DIntArray.length = numRows + 1;
            GBRowHeights1DIntArray.fill(25);
            GBRowHeights1DIntArray[headerRow - 1] = 35;

            let cellValues2DArray = [];
            let hAlignments2DByteArray = [];
            let rDec2DByteArray = [];
            let lockedCells2DBoolArray = [];
            let FontColors = [];
            let a = 1;
            for (let r = 1; r <= numRows; r++) {
                cellValues2DArray.push([]);
                hAlignments2DByteArray.push([]);
                rDec2DByteArray.push([]);
                lockedCells2DBoolArray.push([]);
                FontColors.push([]);
                for (let c = 1; c <= numCols; c++) {
                    cellValues2DArray[r - 1].push("");
                    rDec2DByteArray[r - 1].push(2); // 2 decimals per number
                    hAlignments2DByteArray[r - 1].push(1); // right-align numbers
                    lockedCells2DBoolArray[r - 1].push(true); // lock everything but target column
                    if (c == 2) FontColors[r - 1].push(0x666666);
                    else FontColors[r - 1].push(0x000000);
                    if (r > 1) {
                        if (c === ageGroupCol) {
                            cellValues2DArray[r - 1][c - 1] = getVMMC_AgeGroupStr(a);
                        } else if (c === baseCovCol) {
                            cellValues2DArray[r - 1][c - 1] = VMMC_Coverage[a - 1][DMConst.baseCoverage - 1];
                        } else if (c === targCovCol) {
                            cellValues2DArray[r - 1][c - 1] = VMMC_Coverage[a - 1][DMConst.targetCoverage - 1];
                        }
                    }

                    /* Row and column headings should have an rDec of 0. */
                    if (c === ageGroupCol || r === headerRow) {
                        rDec2DByteArray[r - 1][c - 1] = 0;
                    }

                    /* Left align text in row headings. */
                    if (c === ageGroupCol) {
                        hAlignments2DByteArray[r - 1][c - 1] = 0;
                    } else if (r === headerRow) {
                        /* Center column headings */
                        hAlignments2DByteArray[r - 1][c - 1] = 2;
                    }

                    /* Unlock target coverage column. */
                    if (r > headerRow && c === targCovCol) {
                        lockedCells2DBoolArray[r - 1][c - 1] = false;
                    }
                }

                if (r !== headerRow) {
                    a++;
                }
            }

            cellValues2DArray[headerRow - 1][baseCovCol - 1] = "Base " + VMMC_BaseCoverageYear;
            cellValues2DArray[headerRow - 1][targCovCol - 1] = "Target";

            // for (let a = 1; a < numRows; a++) {
            //
            //     cellValues2DArray[a][ageGroupCol - 1] = getVMMC_AgeGroupStr(a);
            //     cellValues2DArray[a][baseCovCol - 1] = VMMC_Coverage[a - 1][DMConst.baseCoverage - 1];
            //     cellValues2DArray[a][targCovCol - 1] = VMMC_Coverage[a - 1][DMConst.targetCoverage - 1];
            //
            // }
            //console.log(FontColors);
            const maleCircPackTable = {
                Alignments: hAlignments2DByteArray,
                BandsOn: true,
                id: 1,
                RDec: rDec2DByteArray,
                GBColCount: numCols,
                GBColWidths: GBColWidths1DIntArray,
                GBFixedCols: 1,
                GBFixedRows: 1,
                GBRowCount: numRows,
                GBRowHeights: GBRowHeights1DIntArray,
                LockedCells: lockedCells2DBoolArray,
                tableData: {
                    value: cellValues2DArray,
                },
                FontColors: FontColors,
                // title           : "Results",
                // vAlignments     : vAlignments2DByteArray,
                // WordWrappedCols : WordWrappedCols,
            };
            //maleCircPackTable.FontColors[1][1] = 'pink'
            //console.log(maleCircPackTable);

            let maleCircCovTable;
            if (maleCircCovRG.props.itemIndex === 0)
                maleCircCovTable = (
                    <GBStdTable
                        headerBackgroundColor={Theme.HL_PrimaryColor}
                        oddRowBackgroundColor={Theme.HL_BandColor}
                        packTable={maleCircPackTable}
                        onPackTableChanged={this.onTargCovChanged}
                        onPasteStart={this.onPasteStart(this.props, this.state)}
                        processCellFromClipboard={this.processCellFromClipboard(this.state)}
                        style={{
                            marginLeft: indent2,
                            marginTop: 3,
                        }}
                        width={width - indent2 - rightMargin}
                        //fontColors      = {FontColors}
                    />
                );

            //console.log(maleCircCovTable);
            //maleCircCovTable.packTable.FontColors[1][1] = 'pink'

            const downloadOutputTableBtn = (
                <TButton
                    caption={"Download output table"}
                    onClick={this.onDownloadOutputTableBtnClick}
                    containerStyle={{
                        marginLeft: indent2,
                        marginTop: 20,
                    }}
                />
            );

            const dataEntryLab = null;
            /*
                <TLabel
                    caption = {"Data entry"}
                    style = {{
                        ...majorLabStyle,
                        marginTop  : 15,
                    }}
                />;
                */

            const downloadCountryTemplateBtn = null;
            /*
                <TButton

                    caption        = {"Download country template"}
                    captionStyles = {{
                        marginLeft  : 5,
                        marginRight : 5,
                    }}
                    onClick        = {this.onDownloadCountryTemplateBtnClick}
                    containerStyle = {{
                        marginLeft : indent2,
                        marginTop  : 10,
                    }}
                />;
                */
            let uploadCountryTemplateBtn = null;
            let inputDialog = null;

            if (selectedCountryMstID !== DMConst.countryCodeSampleCountry) {
                uploadCountryTemplateBtn = null;
                /*
                    <TButton
                        caption        = {"Upload country template"}
                        onClick        = {this.onUploadCountryTemplateBtnClick}
                        containerStyle = {{
                            marginLeft : indent2,
                            marginTop  : 10,
                        }}
                    />;
                    */

                inputDialog = (
                    <input
                        type="file"
                        accept=".xlsx"
                        ref="importUploader"
                        style={{
                            display: "none",
                        }}
                        onChange={this.onUploadCountryTemplate}
                    />
                );
            }

            if (window.VIPT_Version === window.VIPT_Versions.Global) {
            }

            return (
                <div>
                    {optionsLab}
                    {DataPrepAndUploadLink}
                    {countryDiv}
                    {provinceDiv}
                    {SNU_Div}
                    {targetYearDiv}
                    {fiscalYearStartDiv}
                    {showGlobalOutputsCheckBoxLab}

                    {maleCircCovRG}
                    {maleCircCovTable}
                    {downloadOutputTableBtn}
                    {dataEntryLab}
                    {downloadCountryTemplateBtn}
                    {uploadCountryTemplateBtn}
                    {inputDialog}
                </div>
            );
        } catch (exception) {
            return (
                <div
                    className={"DMAppSideBarCustomDiv"}
                    key={"DMAppSideBarCustomDiv"}
                >
                    <h3 key={"DMAppSideBarCustomDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default DMAppSideBarCustom;
